interface EmailProvider {
  name: string;
  domains: string[];
  inboxUrl: string;
}

export const EMAIL_PROVIDERS: EmailProvider[] = [
  {
    name: "Gmail",
    domains: ["gmail.com", "googlemail.com"],
    inboxUrl: "https://mail.google.com/mail/u/0/#inbox",
  },
  {
    name: "Outlook",
    domains: ["outlook.com", "hotmail.com", "live.com", "msn.com"],
    inboxUrl: "https://outlook.live.com/mail/0/inbox",
  },
  {
    name: "Yahoo",
    domains: ["yahoo.com", "ymail.com"],
    inboxUrl: "https://mail.yahoo.com/",
  },
  {
    name: "iCloud",
    domains: ["icloud.com", "me.com", "mac.com"],
    inboxUrl: "https://www.icloud.com/mail/",
  },
];

export function getEmailProviderOpenTarget(
  userEmail: string
): { provider: string; inboxUrl: string } | null {
  const atIndex = userEmail.lastIndexOf("@");
  if (atIndex === -1) return null;

  const domain = userEmail.slice(atIndex + 1).toLowerCase().trim();
  if (!domain) return null;

  const match = EMAIL_PROVIDERS.find((p) =>
    p.domains.includes(domain)
  );
  if (!match) return null;

  return { provider: match.name, inboxUrl: match.inboxUrl };
}

export function attemptOpenEmailInbox(userEmail: string): boolean {
  const target = getEmailProviderOpenTarget(userEmail);
  if (!target) return false;

  const opened = window.open(target.inboxUrl, "_blank", "noopener,noreferrer");
  return opened !== null;
}
